<template>
    <modal v-if="treeModal" @close="ActionButton('close')" width="500px">
        <template slot="header">
            <h4 class="modal-title">Item da árvore de sortimento</h4>
            <md-button
                class="md-simple md-just-icon md-round modal-default-button"
                @click="ActionButton('close')"
            >
                <md-icon>clear</md-icon>
            </md-button>
        </template>

        <template slot="body">
            <v-draggable-treeview
                v-model="treeData"
                :editable="false"
                :openCallback="readTreeChild"
                :clickCallback="selectTreeChild"
            ></v-draggable-treeview>
        </template>
    </modal>
</template>
<script>
import { Modal, VuetifyDraggableTreeview } from '@/components'
import NodeService from '@/services/node.service'

export default {
    name: 'ModalTree',
    components: {
        Modal,
        'v-draggable-treeview': VuetifyDraggableTreeview
    },
    props: {
        ActionButton: {
            type: Function,
            require: false
        },
        treeModal: Boolean
    },
    data() {
        return {
            treePage: {}
        }
    },
    computed: {
        treeData() {
            return [{ name: 'Todos os itens', id: null }]
        }
    },
    methods: {
        async readTreeChild(item) {
            if (!item) item = {}
            try {
                let page = await NodeService.read(item.id)
                page.data.results.forEach(e => (e.checked = !!item.checked))
                if (typeof item.children == Array) {
                    item.children.concat(page.data.results)
                } else {
                    item.children = page.data.results
                }

                this.treePage = page.data

                return page.data.results
            } catch (e) {
                if (e && e.response) return e.response.status
                else return 500
            }
        },
        async selectTreeChild(item) {
            let ancestorsData
            this.ActionButton('filterNode', item)

            try {
                let ancestors = await NodeService.readAncestors(item.id)
                ancestorsData = ancestors.data
            } catch (e) {
                if (e && e.response) return e.response.status
                else return 500
            }

            if (item.id == null) {
                this.ActionButton('filterNodeName', 'Todos os itens')
                this.ActionButton('close')
            } else {
                let filterNodeName = ''
                ancestorsData.forEach((ancestor, index) => {
                    if (index > 0) filterNodeName += ' > '
                    filterNodeName += ancestor.name
                })

                this.ActionButton('filterNodeName', filterNodeName)
                this.ActionButton('close')
            }
        }
    }
}
</script>
